<template>
  <v-container fluid class="pa-0">
    <SplitpanesLayout :hide-preview="$route.name == 'ViewJobOrder'">

      <template v-slot:list>
        <v-list v-if="loading">
          <v-list-item>
            <v-progress-linear indeterminate></v-progress-linear>
          </v-list-item>
        </v-list>
        <v-list class="pa-3 ma-0" :class="$route.name == 'ViewJobOrder' ? '' : 'pr-0'"
          style="background-color: #00000008; min-height: calc(100% - 1px);">
          <div v-for="entry in jobs" :key="entry.JobId">
            <WarningBanner :warning-messages="getWarningMessages(entry)">
            </WarningBanner>
            <v-card style="position: relative;" class="mb-3" outlined>
              <v-row no-gutters
                :class="($route.params.machineJobId === entry.JobId && $route.name === 'JobAddOrderLine') ? 'rivery' : ''">
                <v-col cols="0" :style="entry.JobLocked || entry.OrderLocked ? '' : 'max-width: calc(100% - 160px);'">
                  <MachineLi :machine="entry.Machine" style="padding-left: 12px !important"
                    @select="selectMachine(entry)" :showServiceAgreement="false">
                  </MachineLi>
                </v-col>
                <template v-if="!entry.JobLocked && !entry.OrderLocked">
                  <v-spacer></v-spacer>
                  <v-col cols="auto" class="d-flex align-center">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-if="entry.Machine.MachineModel" v-bind="attrs" v-on="on" color="tertiary" dark small
                          class="px-1 mr-2" style="min-width: unset; z-index: 20;"
                          :to="getAddLineRoute(entry.JobId, 'model')">
                          <v-icon size="18">mdi-plus</v-icon>
                          <v-icon size="18">$machine_model</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t('translate.commonparts') }}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" color="primary" dark small class="px-1 mr-2"
                          style="min-width: unset; z-index: 20;" :to="getAddLineRoute(entry.JobId, 'internal')">
                          <v-icon size="18">mdi-plus</v-icon>
                          <v-icon size="18">mdi-clock</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t('servicesystem.common_objects.time_report.hours') }}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" color="quaternary" dark small class="px-1 mr-2"
                          style="min-width: unset; z-index: 20;" :to="getAddLineRoute(entry.JobId, '')">
                          <v-icon size="18">mdi-plus</v-icon>
                          <v-icon size="18">$article</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t('servicesystem.common_objects.machine.parts') }}</span>
                    </v-tooltip>
                  </v-col>
                </template>
              </v-row>

              <v-divider v-if="entry.OrderDetails.length"></v-divider>

              <v-list dense class="ma-0 pa-0">
                <OrderDetailListItem v-for="item in entry.OrderDetails" :key="entry.JobId + '_' + item.Id" :item="item"
                  :to="{
                    name: 'JobEditOrderLine',
                    params: { filter: $route.params.filter, jobId: $route.params.jobId, machineJobId: entry.JobId, lineId: item.Id }
                  }">
                </OrderDetailListItem>
              </v-list>
            </v-card>
          </div>

        </v-list>
        <v-divider />
      </template>

      <template v-slot:preview>
        <router-view :userEmploymentId="userEmploymentId" :employmentList="employmentList" :createFunc="handleCreate"
          :updateFunc="handleUpdate" :deleteFunc="handleDelete" :orderLocked="OrderLocked" :jobLocked="JobLocked">
        </router-view>
      </template>
    </SplitpanesLayout>
  </v-container>
</template>


<script>
import Vue from "vue";
import clientAPI from "@/api/ClientAPIMixin.js";
import MachineLi from "@/components/ListItems/MachineListItem.vue";
import SRConst from "@/helpers/Constants/SignalRConstants.js";
import SplitpanesLayout from "@/views/layouts/PreviewableList.vue";
//import moment from "moment";
import OrderDetailListItem from "@/components/ListItems/OrderDetailListItem.vue";
import WarningBanner from "@/components/WarningBanner.vue";

export default {
  name: "ViewJobOrder",
  components: {
    SplitpanesLayout,
    MachineLi,
    OrderDetailListItem,
    WarningBanner,
  },
  mixins: [clientAPI],

  data() {
    return {
      toggleView: ["time", "parts"],
      technicianLimitSelectToOwnStore: null,
      selectedMachineEntry: null,
      loading: true,
      selectedJob: null,
      jobs: [],
      dialogtrigger: 1,
      employmentList: [],
      userEmploymentId: this.userInfo?.EmploymentId?.trim(),
    };
  },

  mounted() {
    this.preload();
    this.getEmployments();
    this.$store.dispatch("NotificationStore/subscribe", [
      SRConst.EventKeys.OrderChange,
      this.notifyChanges
    ]);

    this.checkUserInfoVersion();
  },

  beforeDestroy() {
    this.$store.dispatch("NotificationStore/unsubscribe", [
      SRConst.EventKeys.OrderChange,
      this.notifyChanges
    ]);
  },

  methods: {
    checkUserInfoVersion() {
      var testprop = this.userInfo.StoreId;
      if (!testprop) {
        this.$store.dispatch("getUserInfo", true);
      }
    },

    getWarningMessages(childOrder) {
      const messages = [];
      // Specifically show info when order is locked and job is unfinished.
      if (childOrder.OrderLocked && !childOrder.JobLocked) {
        messages.push({
          severity: 1,
          message: this.$t('servicesystem.common_objects.order.order_locked_by_order_status', { skey: childOrder.OrderStatusText }),
        });
      }
      return messages;
    },

    getAddLineRoute(machineJobId, quickfilter) {
      var formatted = quickfilter ? `"${quickfilter}"` : undefined;
      return {
        name: 'JobAddOrderLine',
        params: { filter: this.$route.params.filter, jobId: this.$route.params.jobId, machineJobId: machineJobId },
        query: { 'OD-PP-filter-quick': formatted }
      };
    },

    notifyChanges(data) {
      if (this.jobs && this.jobs.find(e => e.OrderId.includes(data.orderId))) {
        this.preload(false)
      }
    },

    async handleCreate(payload) {
      const mJob = this.jobs.find(e => e.JobId == payload.JobId)
      var result = await clientAPI.methods.createOrderDetail(payload);
      mJob.OrderDetails.push(result);
      console.log("Added item:", result, mJob);
      return result;
    },

    async handleUpdate(payload) {
      const mJob = this.jobs.find(e => e.JobId == payload.JobId)
      const index = mJob.OrderDetails.findIndex(e => e.Id == payload.Id)
      if (index > -1) {
        Vue.set(mJob.OrderDetails, index, { ...mJob.OrderDetails[index], loading: true });
      }
      var result = await clientAPI.methods.updateOrderDetail(payload);
      if (index > -1) {
        Vue.set(mJob.OrderDetails, index, result);
      }
      console.log("Changed item:", result);
      return result;
    },

    async handleDelete(payload) {
      const mJob = this.jobs.find(e => e.JobId == payload.JobId)
      const index = mJob.OrderDetails.findIndex(e => e.Id == payload.Id)
      if (index > -1) {
        Vue.set(mJob.OrderDetails, index, { ...mJob.OrderDetails[index], loading: true });
      }
      await clientAPI.methods.deleteOrderDetail(payload.Id);
      if (index > -1) {
        mJob.OrderDetails.splice(index, 1);
      }
      console.log("Deleted item:", payload);
    },

    /*
    calculateTime(entry) {
      const sumOfHours = entry.Items.reduce((a, b) => a = a + b.Hours, 0.0);
      var readableForm = moment(0).set("hours", sumOfHours).format('H [Hours] m [Minutes]');
      return readableForm;
    },
    */

    getEmployments() {
      clientAPI.methods.getEmploymentList()
        .then(data => {
          this.employmentList = data.map(e => {
            e.Id = e.Id.trimEnd();
            return e;
          });
        });
    },

    selectMachine(entry) {
      if (!this.OrderLocked && !this.JobLocked) {
        const machine = entry.Machine;
        const hasCommonParts = machine.MachineModel != null;
        this.$router.push(this.getAddLineRoute(entry.JobId, hasCommonParts ? 'model' : ''));
      }
    },

    async preload(showload = true) {
      this.loading = showload;
      const jobId = this.$route.params.jobId;
      await clientAPI.methods.getOrderView(jobId)
        .then(response => {
          console.log("Order view: ", response);
          this.jobs = response;
        });
      this.loading = false;
    },
  },

  computed: {
    JobDetails() {
      return this.$store.getters["JobHub/JobDetails"];
    },
    Subjobs() {
      return this.$store.getters["JobHub/Subjobs"];
    },

    OrderLocked() {
      var firstChildJob = this.jobs?.[0];
      return firstChildJob?.OrderLocked;
    },
    JobLocked() {
      var firstChildJob = this.jobs?.[0];
      return firstChildJob?.JobLocked;
    },
  },
};
</script>


<style lang="scss" scoped>
.rivery::before {
  background-color: transparent !important;
  background: none !important;
}

.rivery::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  background-color: transparent;
  height: 100%;
  width: 100%;
  border: 2px solid var(--v-primary-base) !important;
  border-left-width: 3px !important;
  border-right: none !important;
  opacity: 1 !important;
  border-radius: 4px 0px 0px 4px !important;
}
</style>